// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3ubm2","label":"Section_label__3JC09","contentWrap":"Section_contentWrap__3M7gm","footer":"Section_footer__1twoI","footerInner":"Section_footerInner__33yQF"};